import * as React from "react";

export const fillColor = isDmipPlatform
  ? "var(--monitoring-theme-color)"
  : "var(--primary-color-1)";

export const FlowPreviewBackground = () => (
  <svg
    width="426"
    height="238"
    viewBox="0 0 426 238"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M423.138 232.361C351.699 255.619 300.995 213.173 233.372 209.552C158.36 205.535 51.9306 257.587 12.4347 210.369C-27.223 162.957 40.9144 81.4964 69.3074 13.4091C99.2286 -58.3432 97.5574 -155.388 179.684 -190.702C263.68 -226.819 305.857 -135.207 382.527 -121.271C446.082 -109.719 532.563 -151.053 579.397 -118.048C639.73 -75.5297 691.358 -6.38658 656.493 71.7986C621.593 150.06 514.81 202.516 423.138 232.361Z"
      fill={fillColor}
    />
  </svg>
);
